/**
 * Created by lipengfei.
 * 工作流进度展示
 */
import Component from "../../../../lib/component";
import template from './right.content.workflowcontent.html';
import './right.content.workflowcontent.scss';
import Mediator from '../../../../lib/mediator';
import {PMAPI} from '../../../../lib/postmsg';

let config = {

    template: template,
    data: {},
    actions: {
        toPercent: function (point) {
            let str = Number(point * 100).toFixed(1);
            str += "%";
            return str;
        },
        /**
         * 加载工作进度
         */
        showfirst() {
            let record_progress = this.actions.toPercent(this.data['record_progress']);
            this.el.find(".workflow-schedule").css({"width": record_progress});
            this.el.find(".workflow-content-title").attr("title",this.data.name);
        },
        /**
         * 打开与我相关工作
         */
        openMyWork: function (isView) {
            PMAPI.openDialogByIframe(
                `/wf/approval/?record_id=${this.data['id']}&form_id=${this.data['form_id']}&table_id=${this.data['table_id']}&flow_id=${this.data['flow_id']}${isView?'&btnType=view':''}`,
                {
                    width: "100%",
                    height: '900',
                    title:this.data.wf_approve_type || '',
                    modal: true,
                    customSize: true,
                },{
                    current_node: this.data.current_node
                }).then(data => {
                Mediator.emit('Calendar: tool', {toolMethod: 'refreshData'});
            })
        },
    },
    binds: [
        {
            event: 'click',
            selector: '.workflow-content',
            callback: function () {
                if(this.data.start_handler===top.config.sysConfig.userInfo.name){
                    this.actions.openMyWork(true);
                }else{
                    this.actions.openMyWork();
                }
            }
        },
    ],
    afterRender: function () {
        this.el.css("width", "100%");
        this.actions.showfirst();
    },
};

let RightContentWorkFlow = Component.extend(config);

export default RightContentWorkFlow;
// class RightContentWorkFlow extends Component {
//     constructor(data,newConfig) {
//         config.data = data;
//         super($.extend(true,{},config,newConfig));
//     }
// }
//
// export default RightContentWorkFlow;


// WEBPACK FOOTER //
// app/components/calendar/right-content/right.content.workflowcontent/right.content.workflowcontent.js